import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { pageLabels, pageTypes } from '@src/constants/common';

const MAX_PAGE_TABS_COUNT = 8;

const defaultOpenedPages = [
  {
    path: pageTypes.HOME,
    name: pageLabels[pageTypes.HOME],
  },
];

const initialState = {
  openedPages: defaultOpenedPages,
  currentPagePath: '/home',
};

const generatePathToPage = (path) => ({
  path,
  name: pageLabels[path],
});

export const { actions, reducer } = createSlice({
  name: 'pageTabs',
  initialState,
  reducers: {
    initializePages: (state, { payload: path }) => {
      const prevOpenedPages = JSON.parse(sessionStorage.getItem('openedPages')) || defaultOpenedPages;

      const isOpenedPage = !!_.find(prevOpenedPages, (p) => p.path === path);
      if (!isOpenedPage) {
        const page = generatePathToPage(path);
        prevOpenedPages.push(page);
      }

      state.openedPages = prevOpenedPages;
      sessionStorage.setItem('openedPages', JSON.stringify(prevOpenedPages));
    },
    openPage: (state, { payload: path }) => {
      const isOpenedPage = !!_.find(state.openedPages, (p) => p.path === path);
      if (isOpenedPage) return;
      const page = generatePathToPage(path);
      const nextPages = [
        ...state.openedPages,
        page,
      ];
      if (state.openedPages.length > MAX_PAGE_TABS_COUNT) {
        nextPages.splice(1, 1);
      }
      state.openedPages = nextPages;
      sessionStorage.setItem('openedPages', JSON.stringify(nextPages));
    },
    closePage: (state, { payload: path }) => {
      const nextPages = _.filter(state.openedPages, (page) => page.path !== path);
      state.openedPages = nextPages;
      sessionStorage.setItem('openedPages', JSON.stringify(nextPages));
    },
    setCurrentPagePath: (state, { payload: path }) => {
      state.currentPagePath = path;
    },
  },
});

export const {
  initializePages,
  openPage,
  closePage,
  setCurrentPagePath,
} = actions;

export default reducer;
